{
  "#MDC_INVENTORY": {
    "TITLE": "Inventur",
    "MODULE_TITLE": "Inventur",
    "DASHBOARD": "Dashboard",
    "TABLE": "Tabelle",
    "NO_DATA": "Keine Daten verfügbar",
    "LIST": {
      "TITLE": "Erfassung",
      "POSITIONS": "Positionen",
      "UNITS": "Einheiten",
      "DIFFERENCE": "Abweich.",
      "SEARCH_PLACEHOLDER": "In Liste suchen…",
      "EMPTY": {
        "TITLE": "Noch keine Artikel erfasst",
        "SUBTITLE": "Scannen Sie einen Barcode oder fügen Sie einen Artikel manuell hinzu, um zu beginnen."
      },
      "NO_RESULTS": "Keine Treffer für „{{ term }}\".",
      "SCAN": "Weiter scannen",
      "SEARCH_MANUAL": "Manuell suchen",
      "ENTER_EAN": "EAN eingeben",
      "FINISH": "Abschließen"
    },
    "DETAIL": {
      "TITLE": "Artikel erfassen",
      "RECOGNISED_BADGE": "Erkannt",
      "RECOGNISED_AS": "Erkannt: EAN-13",
      "EAN": "EAN",
      "EXPECTED_STOCK": "Soll-Bestand",
      "QUANTITY_HEADER": "Menge erfassen",
      "NOTE_HEADER": "Notiz (optional)",
      "NOTE_PLACEHOLDER": "z. B. Beschädigung, Lagerplatz, Charge…",
      "CANCEL": "Abbrechen",
      "APPLY": "Übernehmen"
    }
  },
  "PRODUCTION": {
    "INTERNAL_ERROR": "Die Anfrage konnte nicht verarbeitet werden",
    "INVENTORY": {
      "NOT_FOUND": "Keine offene Inventur gefunden!",
      "ALREADY_FINALIZED": "Die Inventur wurde bereits abgeschlossen!",
      "ARTICLE_REQUIRED": "Artikel wird ben\u00F6tigt!",
      "UNIT_REQUIRED": "Einheit wird ben\u00F6tigt!",
      "QUANTITY_REQUIRED": "Menge wird ben\u00F6tigt!",
      "BBD_REQUIRED": "MHD wird ben\u00F6tigt!",
      "LOT_REQUIRED": "Charge wird ben\u00F6tigt!",
      "STORAGE_LOCATION_REQUIRED": "Lagerplatz wird ben\u00F6tigt!",
      "BELEGKREIS_REQUIRED": "FirmaWws - Inventuraufnahme Belegkreis darf nicht null sein!",
      "ARTICLE_NOT_ON_PALETTE": "Dieser Artikel ist nicht auf der Palette!",
      "MISSING_LAGERSYMBOL": "Kein Lagersymbol f\u00FCr Inventurkorrektur (Mischpalette) in der Firmawws hinterlegt.",
      "NO_FIBUPERIOD": "Keine Fibuperioden mit Datum {{date}} gefunden!",
      "MISSING_VKFORG": "Kein Erfassungs-Vkforg f\u00FCr Lager {{stock}} hinterlegt.",
      "MISSING_LGE_BELEGKREIS": "Kein LGE-Belegkreis f\u00FCr Vkforg {{vkforg}} hinterlegt.",
      "PALETTE_ALREADY_INVENTORIED": "Palette wurde bereits mit Beleg {{belegnummer}} inventiert!",
      "PALETTE_IN_DELIVERY": "Palette {{sscc}} bereits im Lieferschein: {{belegnummer}}, Kunde: {{kundenummer}} {{kurzbez}}",
      "PALETTE_ALREADY_DELIVERED": "Palette {{sscc}} bereits ausgeliefert!",
      "LOCKED_BY_USER": "Inventur vom Anwender '{{user}}' gesperrt!",
      "NOT_FOUND_BY_ID": "Inventur mit ID {{id}} nicht vorhanden!",
      "MANARTIKELDAT_NOT_FOUND": "Manartikeldat mit ID {{id}} nicht vorhanden!",
      "VKPREIS_REQUIRED": "Kein VKPreis bei Sammelartikel ohne Manartikeldat!"
    },
    "MDC": {
      "INVALID" : "Barcode invalid!",
      "NOT_FOUND": "Barcode existiert nicht"
    },
    "PRODUCTION": {
      "MISSING_UNIT": "Artikel {{productnumber}} hat keine Produktionseinheit hinterlegt!"
    }
  }
}
